import React, { useState } from 'react';

import { ApiOrder } from '#/api/types';
import TPSLColumn from '#/components/positions/takeProfitStopLoss/TPSLColumn';
import TPSLModal from '#/components/positions/takeProfitStopLoss/TPSLModal';
import { useSelector } from '#/reduxState/store';

import {
  prepareBothConditionalTPSLOrders,
  replaceConditionalTpSl,
} from './tpSlUtils';

type Props = {
  order: ApiOrder;
};

export default function TPSLOrderColumnWrap({ order }: Props) {
  const wallet = useSelector(state => state.wallet);
  const tickSizes = useSelector(state => state.markets.listedMarkets.tickSizes);

  const maximumPositionSizes = useSelector(
    state => state.markets.listedMarkets.maximumPositionSizes
  );
  const delegatedWallet = useSelector(
    state => state.delegatedKey.authorization
  );

  const maximumPositionSize = maximumPositionSizes[order.market];

  const isActivePositionTPSL = order.originalQuantity === maximumPositionSize;

  const [edit, setEdit] = useState(false);

  const tickSizeDecimals = tickSizes?.[order.market]?.visibleDecimals;

  const isLimitOrLimitStop =
    order.type === 'limit' ||
    order.type === 'stopLossLimit' ||
    order.type === 'takeProfitLimit';

  return (
    <>
      {edit && (
        <TPSLModal
          market={order.market}
          onClose={() => setEdit(false)}
          futureTpSl={{
            parentOrderId: order.orderId,
            parentOrderSide: order.side === 'buy' ? 'long' : 'short',
            parentBuyQuantity:
              order.side === 'buy' ? order.originalQuantity : undefined,
            parentSellQuantity:
              order.side === 'buy' ? undefined : order.originalQuantity,
            parentPriceType: isLimitOrLimitStop
              ? 'limit'
              : order.triggerPrice
              ? 'stop'
              : 'market',
            parentPrice: isLimitOrLimitStop
              ? order.price
              : order.triggerPrice || undefined,
            onSaveOverride: async tpsl => {
              if (!maximumPositionSize) {
                console.error('Not known max position side');
                return;
              }
              const { stopLoss, takeProfit } =
                await prepareBothConditionalTPSLOrders({
                  delegatedWallet,
                  market: order.market,
                  parentOrderSide: order.side,
                  maximumPositionSize,
                  stopLossPrice: tpsl.stopLoss?.triggerPrice,
                  stopLossPriceType: tpsl.stopLoss?.triggerType,
                  takeProfitPrice: tpsl.takeProfit?.triggerPrice,
                  takeProfitPriceType: tpsl.takeProfit?.triggerType,
                  wallet,
                });
              if (!takeProfit && !stopLoss) {
                console.warn('[TPSL] Nothing changed');
                return;
              }
              if (stopLoss) {
                await replaceConditionalTpSl({
                  conditionalOrder: stopLoss,
                  delegatedWallet,
                  parentOrderId: order.orderId,
                  wallet,
                });
              }
              if (takeProfit) {
                await replaceConditionalTpSl({
                  conditionalOrder: takeProfit,
                  delegatedWallet,
                  parentOrderId: order.orderId,
                  wallet,
                });
              }
              setEdit(false);
            },
          }}
        />
      )}
      <TPSLColumn
        onEdit={
          isActivePositionTPSL || order.reduceOnly ? false : () => setEdit(true)
        }
        stopLossPrice={order.conditionalStopLossOrder?.triggerPrice}
        takeProfitPrice={order.conditionalTakeProfitOrder?.triggerPrice}
        tickSizeDecimals={tickSizeDecimals}
      />
    </>
  );
}
